import { useNavigate } from "react-router-dom";

import { FinancePaymentRequestListFeaturePage } from "..";

/** 请款记录页面：点「查看」进这张请款单的详情地址。 */
export function FinancePaymentRequestListPage() {
  const navigate = useNavigate();
  return (
    <FinancePaymentRequestListFeaturePage
      onOpenRequest={(requestId) => navigate(`/finance/payment-requests/${encodeURIComponent(requestId)}`)}
    />
  );
}
